import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';
import './ResourcesPage.css';

// Safety Exit functionality
const quickExit = () => {
  try {
    window.location.replace('https://www.google.com');
  } catch (e) {
    window.location.href = 'about:blank';
  }
};

const ResourcesPage: React.FC = () => {
  const { t } = useLanguage();

  // Sample resources data
  const resources = [
    { title: "Agenția Națională pentru Egalitatea de Șanse între Femei și Bărbați", link: "https://anes.gov.ro" },
    { title: "Fundația Lampas", link: "https://www.lampas.ro/contact" },
    { title: "DGASPC BIHOR", link: "https://www.dgaspcbihor.ro/dgaspcbh.ro/servicii_sociale.html" },
    { title: "Fundația People 2 People", link: "https://www.people2people.ro" },
    { title: "Asociația Anais", link: "https://asociatia-anais.ro" }
  ];

  return (
    <div className="resources-page">
      {/* Safety Exit Button */}
      <div className="safety-exit">
        <button onClick={quickExit} className="safety-exit-link">
          {t('home.safetyExit')}
        </button>
      </div>

      {/* Language Switcher */}
      <div className="home-language-switcher">
        <Link to="/" className="header-home-button" title="Home">
          🏠
        </Link>
        <LanguageSwitcher />
      </div>

      {/* Hero Section */}
      <header className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            {t('resources.hero.title')}
          </h1>
          <p className="hero-subtitle">
            {t('resources.hero.subtitle')}
          </p>
        </div>
      </header>

      {/* Resources Section */}
      <section className="resources-section">
        <div className="container">
          <h2 className="section-title">{t('resources.section.title')}</h2>
          <p className="section-description">
            {t('resources.section.description')}
          </p>
          
          <div className="resources-table-container">
            <table className="resources-table">
              <thead>
                <tr>
                  <th>{t('resources.table.title')}</th>
                  <th>{t('resources.table.link')}</th>
                </tr>
              </thead>
              <tbody>
                {resources.map((resource, index) => (
                  <tr key={index}>
                    <td className="resource-title">{resource.title}</td>
                    <td className="resource-link">
                      <a 
                        href={resource.link} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="resource-link-button"
                      >
                        {t('resources.table.visit')}
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="resources-warning">
            {t('resources.warning')}
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h4>{t('home.footer.about')}</h4>
              <p>{t('home.footer.description')}</p>
            </div>
            <div className="footer-section">
              <h4>{t('home.footer.resources')}</h4>
              <ul>
                <li><a href="/evaluare">{t('home.footer.assessment')}</a></li>
                <li><a href="/resurse">{t('home.footer.resources')}</a></li>
                <li><a href="/#about-us">{t('home.footer.aboutUs')}</a></li>
                <li><a href="/#support">{t('home.footer.support')}</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>{t('home.footer.contact')}</h4>
              <p>{t('home.footer.contactInfo')}</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} {t('home.footer.copyright')}</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ResourcesPage;
